import { render, staticRenderFns } from "./CardUpdateStatus.vue?vue&type=template&id=0dc3421a&scoped=true"
import script from "./CardUpdateStatus.vue?vue&type=script&lang=js"
export * from "./CardUpdateStatus.vue?vue&type=script&lang=js"
import style0 from "./CardUpdateStatus.vue?vue&type=style&index=0&id=0dc3421a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc3421a",
  null
  
)

export default component.exports